/**
 * pi-ugc-slider – Swiper init + inline video/YouTube play. Multi-instance safe.
 */
(function () {
  function initPIUgcSlider() {
    if (typeof window.Swiper === 'undefined') return;

    var containers = document.querySelectorAll('[data-pi-ugc-slider]');
    containers.forEach(function (root) {
      var sectionId = root.getAttribute('data-pi-ugc-slider');
      if (!sectionId) return;

      var sliderEl = root.querySelector('.pi-ugc-slider__slider');
      var nextEl = root.querySelector('.pi-ugc-slider__nav--next');
      var prevEl = root.querySelector('.pi-ugc-slider__nav--prev');
      var paginationEl = root.querySelector('.pi-ugc-slider__pagination');

      if (!sliderEl || sliderEl.getAttribute('data-pi-ugc-slider-inited') === 'true') return;
      sliderEl.setAttribute('data-pi-ugc-slider-inited', 'true');

      var slidesPerView = 1.2;
      var spaceBetween = 16;
      var breakpoint = 752;
      var slidesPerViewDesk = 5.5;
      var spaceBetweenDesk = 20;
      var autoplay = false;
      var autoplaySpeed = 4000;

      try {
        var slidesPerViewAttr = root.getAttribute('data-slides-per-view');
        if (slidesPerViewAttr) slidesPerView = parseFloat(slidesPerViewAttr) || slidesPerView;
        var spaceAttr = root.getAttribute('data-slide-gap');
        if (spaceAttr) spaceBetween = parseInt(spaceAttr, 10) || spaceBetween;
        var breakpointAttr = root.getAttribute('data-breakpoint');
        if (breakpointAttr) breakpoint = parseInt(breakpointAttr, 10) || breakpoint;
        var slidesPerViewDeskAttr = root.getAttribute('data-slides-per-view-desk');
        if (slidesPerViewDeskAttr) slidesPerViewDesk = parseFloat(slidesPerViewDeskAttr) || slidesPerViewDesk;
        var spaceDeskAttr = root.getAttribute('data-slide-gap-desk');
        if (spaceDeskAttr) spaceBetweenDesk = parseInt(spaceDeskAttr, 10) || spaceBetweenDesk;
        if (root.getAttribute('data-autoplay') === 'true') autoplay = true;
        var speedAttr = root.getAttribute('data-autoplay-speed');
        if (speedAttr) autoplaySpeed = parseInt(speedAttr, 10) * 1000 || autoplaySpeed;
      } catch (e) {}

      var slideCount = sliderEl.querySelectorAll('.swiper-slide').length;
      /* If slide count is not greater than ceil(slidesPerView_desktop), Swiper has no overflow
         and locks navigation (next/prev do nothing). Cap desktop slides-per-view so there is
         always room to scroll when slideCount > 1 (e.g. 5 slides @ 5.5 → use 4.5). */
      var effSlidesPerViewDesk = slidesPerViewDesk;
      if (slideCount > 1 && slideCount <= Math.ceil(slidesPerViewDesk)) {
        effSlidesPerViewDesk = Math.min(
          slidesPerViewDesk,
          Math.max(1, slideCount - 0.5)
        );
      }

      /* Loop disabled: duplicated slides make pagination / active index feel like it jumps
         (realIndex vs bullets out of sync). Linear flow with bullets + arrows. */
      var swiperConfig = {
        slidesPerView: slidesPerView,
        spaceBetween: spaceBetween,
        slidesPerGroup: 1,
        loop: false,
        watchOverflow: false,
        roundLengths: true,
        breakpoints: {}
      };

      swiperConfig.breakpoints[breakpoint] = {
        slidesPerView: effSlidesPerViewDesk,
        spaceBetween: spaceBetweenDesk,
        slidesPerGroup: 1
      };

      if (nextEl && prevEl) {
        swiperConfig.navigation = { nextEl: nextEl, prevEl: prevEl };
      }
      if (paginationEl) {
        swiperConfig.pagination = {
          el: paginationEl,
          clickable: true,
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-active'
        };
      }
      if (autoplay) {
        swiperConfig.autoplay = { delay: autoplaySpeed, disableOnInteraction: false };
      }

      var swiper = new window.Swiper(sliderEl, swiperConfig);

      /* In-slide Shopify video: poster click -> show video; close -> hide */
      root.querySelectorAll('[data-pi-ugc-poster]').forEach(function (poster) {
        var layer = poster.closest('[data-pi-ugc-video]').querySelector('[data-pi-ugc-video-layer]');
        var videoEl = layer ? layer.querySelector('video') : null;
        var closeBtn = layer ? layer.querySelector('[data-pi-ugc-close-video]') : null;
        if (!layer) return;
        poster.addEventListener('click', function (e) {
          e.preventDefault();
          layer.style.display = 'flex';
          if (videoEl) {
            videoEl.currentTime = 0;
            videoEl.play().catch(function () {});
          }
        });
        if (closeBtn) {
          closeBtn.addEventListener('click', function () {
            if (videoEl) videoEl.pause();
            layer.style.display = 'none';
          });
        }
      });

      /* YouTube: poster click -> load iframe and show */
      root.querySelectorAll('[data-pi-ugc-youtube]').forEach(function (wrap) {
        var layer = wrap.querySelector('[data-pi-ugc-youtube-layer]');
        var iframe = layer ? layer.querySelector('iframe') : null;
        var closeBtn = layer ? layer.querySelector('[data-pi-ugc-close-youtube]') : null;
        var poster = wrap.querySelector('[data-pi-ugc-youtube-poster], .pi-ugc-slider__poster');
        if (!layer || !iframe) return;
        var src = iframe.getAttribute('data-src');
        if (!src) return;
        if (poster) {
          poster.addEventListener('click', function (e) {
            e.preventDefault();
            iframe.setAttribute('src', src);
            layer.style.display = 'block';
          });
        }
        if (closeBtn) {
          closeBtn.addEventListener('click', function () {
            iframe.setAttribute('src', '');
            layer.style.display = 'none';
          });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPIUgcSlider);
  } else {
    initPIUgcSlider();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-pi-ugc-slider]')) initPIUgcSlider();
  });
})();
